export const isLocalDev = (): boolean => {
    const host = window.location.host;
    return host.startsWith("localhost") || host.includes(".local");
};
